"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainsModal = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('domain', 'setDomain', ''), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (!this.props.isOpen && prevProps.isOpen) {
            this.props.setDomain('');
        }
    }
}), recompose_1.pure);
exports.DomainsModal = enhance(function (props) {
    return (React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: 'sso-management-add-domain' },
        React.createElement(sok_ui_1.Header, { onClose: function () { return props.setIsOpen(false); } }, (0, translation_1.getLocalization)('sso/management/attach/company/header')),
        React.createElement(sok_ui_1.Container, null,
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.addDomainStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILURE'] },
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/domain/creating')),
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/domain/created')),
                React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/domain/failed'))),
            React.createElement("div", { className: 'add-domain' },
                React.createElement("div", null,
                    React.createElement("label", null,
                        (0, translation_1.getLocalization)("sso/management/domains/domainName"),
                        ":")),
                React.createElement("div", null,
                    React.createElement(sok_ui_1.TextInput, { value: props.domain, onChange: function (e) { return props.setDomain(e.target.value); } }),
                    React.createElement(sok_ui_1.Button, { color: 'green', text: (0, translation_1.getLocalization)('userfront/button/add'), size: 'large', onClick: function () { return props.addDomain(props.sso, props.domain); } }))),
            React.createElement("div", { className: 'domains' },
                React.createElement("div", null,
                    React.createElement("label", null,
                        (0, translation_1.getLocalization)("sso/management/domains/domains"),
                        ":")),
                (props.sso.domains || []).map(function (x) { return (React.createElement("div", null, x)); }))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/button/cancel'), onClick: function () { return props.setIsOpen(false); } }))));
});
